export const ACTION_RESET = 'FETCH_BRAND_RESET';
export const ACTION_REQUEST = 'FETCH_BRAND_REQUEST';
export const ACTION_SUCCESS = 'FETCH_BRAND_SUCCESS';
export const ACTION_ERROR = 'FETCH_BRAND_ERROR';
